import { createCtx } from '@shared/util/context';

interface ThreadContextValue {
  channelSlug: string;
}

export const [useThreadContext, ThreadContextProvider] = createCtx<ThreadContextValue>();
